import styled from 'styled-components';

export const StyledLabel = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4375em;
`;

export const BaseLayoutElement = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border: none;
`;
